export enum EnAppName {
  MANGA_ONLINE = 'MangaOnline',
  HMANGA = 'HManga',
  HOT_MANGA = 'HotManga',
  MANGA_HENTAI = 'MangaH',
}
